import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=9a5b73a2&"
import script from "./Checkbox.vue?vue&type=script&lang=ts&"
export * from "./Checkbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a5b73a2')) {
      api.createRecord('9a5b73a2', component.options)
    } else {
      api.reload('9a5b73a2', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=9a5b73a2&", function () {
      api.rerender('9a5b73a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/inputs/Checkbox.vue"
export default component.exports